import { useSeoMeta } from '@unhead/react';
import { SprayCan } from 'lucide-react';
import { CraftProfileForm } from '@/components/CraftProfileForm';
import {
  SKATE_GRAFFITI_KIND, GRAFFITI_STYLE_LABELS, GRAFFITI_MEDIUM_LABELS, GRAFFITI_CONTEXT_LABELS,
} from '@/lib/types';

export default function BecomeGraffitiPage() {
  useSeoMeta({
    title: 'Offer Graffiti / Murals - SkateSpots',
    description: 'List your graffiti & mural work — pieces, murals, skatepark art and more.',
  });

  return (
    <CraftProfileForm
      config={{
        kind: SKATE_GRAFFITI_KIND,
        selfTag: 'skategraffiti',
        identifier: 'graffiti-profile',
        heading: 'Graffiti / Mural Artist',
        tagline: 'Pieces, murals, skatepark art — paint the scene',
        noun: 'graffiti artist',
        accentText: 'text-lime-400',
        accentBg: 'bg-lime-500',
        accentChip: 'bg-lime-500 text-black border-lime-500',
        accentChipHover: 'hover:border-lime-500/60 hover:text-lime-400',
        icon: SprayCan,
        rateLabel: 'Rate',
        portfolioLabel: 'Portfolio link (IG, site)',
        skillSections: [
          { title: 'Style', entries: Object.entries(GRAFFITI_STYLE_LABELS), required: true },
          { title: 'Medium', entries: Object.entries(GRAFFITI_MEDIUM_LABELS) },
          { title: 'Work Context', entries: Object.entries(GRAFFITI_CONTEXT_LABELS) },
        ],
        extraFields: [
          { tag: 'crew', label: 'Graffiti Crew', placeholder: 'Your writing crew (optional)', helper: 'Separate from your skate crew — the writers you paint with.' },
        ],
      }}
    />
  );
}
